import LayoutRendererState, {
    initialLayoutRendererState,
} from 'layoutRenderer/LayoutRendererState';
import { LayoutRendererActionType, LayoutRendererAction } from './actions';
import { Reducer } from 'redux';

const reducer: Reducer<LayoutRendererState, LayoutRendererAction> = (
    state = initialLayoutRendererState,
    action
) => {
    switch (action.type) {
        case LayoutRendererActionType.LOCK_LAYOUT:
            return {
                ...state,
                locked: true,
            };
        case LayoutRendererActionType.UNLOCK_LAYOUT:
            return {
                ...state,
                locked: false,
            };
        case LayoutRendererActionType.REQUEST_ADD_WIDGETS:
            return {
                ...state,
                locked: false,
                pendingWidgetsToAdd: action.payload!,
            };
        case LayoutRendererActionType.CONFIRM_ADD_WIDGETS:
            return {
                ...state,
                pendingWidgetsToAdd: [],
            };
        default:
            return state;
    }
};

export default reducer;
